import React, { useCallback, useEffect, useState } from "react";
import { Tables } from "../../components/Elements/Tables/Tables";
import { ReactComponent as EyeIcon } from "../../assets/svgs/eye-icon.svg";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { ReactComponent as BackIcon } from "../../assets/svgs/back-square.svg";
import { useNavigate } from "react-router-dom";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { getApi } from "../../api/api_instance";
import { useLocation } from "react-router-dom";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import AddModifyButton from "./components/AddModifyButton";
import { API_URLS } from "../../api/apiUrls";
import QuestionDialog from "../StandardForms/DialogBoxes/QuestionDialog";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";
const Sections = ({ formId, onSectionSelect, approved }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    open: false,
    title: "",
    message: "",
  });
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const handleAddModifyClick = () => {
    if (approved === true) {
      setPopup({
        open: true,
        title: "Form Already Approved",
        message:
          "This Standard Form has already been approved and is currently locked for editing. To make modifications, the manager must unlock it or change its status to Draft first.",
      });
      return;
    }
    setOpenCreateDialog(true);
  };
  
  //popup auto close
 useEffect(() => {
    if (popup.open) {
      const timer = setTimeout(() => {
        setPopup((prev) => ({
          ...prev,
          open: false,
        }));
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [popup.open]);
  
  const fetchTableData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.GET_STANDARD_SECTIONSBY_ID(formId),
      });
      if (response.success) {
        setTotalRecords(response?.data?.totalSections || 0);
        const data = response?.data || [];

        const formattedData = (response?.data.sections || []).map(
          (item, index) => ({
            key: item.id,
            serial: (currentPage - 1) * pageSize + index + 1,
            section: item.name || "-",
            totalSubSection: item.totalSubsections || 0,
            totalQuestion: item.totalQuestions || 0,
            action: (
              <div className="flex gap-4 items-center justify-center">
                <EyeIcon
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    onSectionSelect({
                      sectionName: item.name,
                      sectionId: item.sectionId,
                    })
                  }
                />
              </div>
            ),
          }),
        );
        setTableData(formattedData);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching section data:", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  }, [currentPage, pageSize, searchTerm, navigate]);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Section", key: "section" },
    { label: "Total Sub-Section", key: "totalSubSection" },
    { label: "Total Question", key: "totalQuestion" },
    { label: "Action", key: "action" },
  ];

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);
 
  useEffect(() => {
    fetchTableData();
  }, [fetchTableData]);

  return (
    <div style={{ backgroundColor: "#fff" }} className="h-screen">
      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
        }}
      >
        <div className="flex justify-between mx-8">
          <div className="flex gap-4 pl-3">
            <p className="px-8  h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
              TOTAL SECTION {totalRecords}
            </p>

            <SearchBar
              width="200px"
              onSearch={(value) => setSearchTerm(value)}
            />
          </div>
          <div className="flex gap-5">
            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText=" View All Question"
              className="text-[16px] font-normal h-[50px] w-[200px]"
              // onClick={() => navigate(`/view/${formId}`)}
              onClick={() =>
                navigate(`/standard-forms/${formId}/all-questions`)
              }
            />
            <AddModifyButton onClick={handleAddModifyClick} />
          </div>
        </div>
        <div className="mx-2 pt-2">
          <Tables
            data={tableData}
            headers={headers}
            pageSize={pageSize}
            total={totalRecords}
            current={currentPage}
            loading={loading}
            onChange={handlePageChange}
          />
        </div>
      </div>
      {openCreateDialog && (
        <QuestionDialog
          onOpen={openCreateDialog}
          formId={formId}
          onClose={() => setOpenCreateDialog(false)}
        />
      )}

      {popup.open && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20">
          <PopupCard
            title={popup.title}
            type="error"
            message={popup.message}
            onOpen={popup.open}
            onClose={() => setPopup((prev) => ({ ...prev, open: false }))}
          />
        </div>
      )}
    </div>
  );
};

export default Sections;
